import { HomeCardId } from '../constants';
import { Compute } from './Compute';
import { Docs } from './Docs';
import { MyApps } from './MyApps';
import { MyCompute } from './MyCompute';
import { MyDatasets } from './MyDatasets';
import { NewFeatures } from './NewFeatures';
import { MyModels } from './MyModels';
import { MyModules } from './MyModules';
import { MyWorkflows } from './MyWorkflows';
import { Quickstart } from './Quickstart';
import { RecentActivity } from './RecentActivity';
import { TrendingModels } from './TrendingModels';

export const mapIdToComponent = {
  [HomeCardId.NewFeatures]: NewFeatures,
  [HomeCardId.Compute]: Compute,
  [HomeCardId.MyCompute]: MyCompute,
  [HomeCardId.RecentActivity]: RecentActivity,
  [HomeCardId.TrendingModels]: TrendingModels,
  [HomeCardId.Quickstart]: Quickstart,
  [HomeCardId.Docs]: Docs,
  [HomeCardId.MyApps]: MyApps,
  [HomeCardId.MyModels]: MyModels,
  [HomeCardId.MyWorkflows]: MyWorkflows,
  [HomeCardId.MyDatasets]: MyDatasets,
  [HomeCardId.MyModules]: MyModules,
};

export const mapIdToTitle = {
  [HomeCardId.RecentActivity]: 'Your Recent Activity',
  [HomeCardId.Compute]: 'Set Up Compute',
  [HomeCardId.MyCompute]: 'Your Compute',
  [HomeCardId.NewFeatures]: 'NewFeatures',
  [HomeCardId.TrendingModels]: 'Test Trending AI Models',
  [HomeCardId.Quickstart]: 'Quickstart For Developers',
  [HomeCardId.Docs]: 'Learn & Build With AI',
  [HomeCardId.MyApps]: 'My Apps',
  [HomeCardId.MyModels]: 'My Models',
  [HomeCardId.MyWorkflows]: 'My Workflows',
  [HomeCardId.MyDatasets]: 'My Datasets',
  [HomeCardId.MyModules]: 'My Modules',
};
